import questions from './questions.json';

const initialState = {
  questions: []
};

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_FAQ': {
      return { ...state, questions };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/faq/reducer.js